export enum JobTypeEnum {
    Job = "Job",
    Project = "Project",
    Contract = "Contract"
}